import { useState, useEffect, useCallback } from 'react';
import useTokenStore from '../store/store';
import { listSavedSearches } from '../utils/savedSearches';
import { SavedSearch } from '../types/savedSearch';

// The signed-in buyer's saved searches. Effect-scoped with a cancellation
// guard (useBuyerReservations pattern): a response landing after logout or a
// token swap is discarded, and the list fails closed to empty.
export const useSavedSearches = () => {
  const [searches, setSearches] = useState<SavedSearch[]>([]);
  const [loading, setLoading] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  const getToken = useTokenStore((state) => state.token);

  useEffect(() => {
    setSearches([]);
    setLoading(false);
    if (!getToken) return;
    let active = true;
    setLoading(true);
    listSavedSearches(getToken)
      .then((result) => {
        if (active) setSearches(result.data);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [getToken, reloadKey]);

  const refetch = useCallback(() => setReloadKey((key) => key + 1), []);

  return { searches, loading, refetch };
};
